import { defineMessages } from 'react-intl';

export default defineMessages({
  waitlistStatusCardAcceptText: {
    id: 'waitlist.StatusCardAcceptText',
    defaultMessage: "Accept",
    description: 'Click here to accept the offer',
  },
  waitlistStatusCardDeclineText: {
    id: 'waitlist.StatusCardDeclineText',
    defaultMessage: "Decline",
    description: 'Click here to decline the offer',
  },
  waitlistStatusCardDeclinedNotetext: {
    id: 'waitlist.StatusCardDeclinedNotetext',
    defaultMessage: "To change your offer status, you can add your child back to the waitlist of this program.",
    description: 'Declined offer note text',
  },
  waitlistStatusCardStatusText: {
    id: 'waitlist.waitlistStatusCardStatusText',
    defaultMessage: "Status:",
    description: 'Status label',
  },
  offerResponseAccepted: {
    id: 'waitlist.offerResponseAccepted',
    defaultMessage: "Accepted!",
    description: 'Offer Response Accepted',
  },
  offerResponseDeclined: {
    id: 'waitlist.offerResponseDeclined',
    defaultMessage: "Declined",
    description: 'Offer Response Declined',
  },
  waitlistStatusCardStartDateText: {
    id: 'waitlist.CardStartDateText',
    defaultMessage: "Start Date",
    description: 'Label for the start date',
  },
});
